import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Alert, AlertTitle, Box } from '@mui/material';

export default function DisclaimerAccordion() {
  return (
    <Box>
      <Alert
        icon={false}
        severity="info"
        sx={{
          margin: 2
        }}
      >
        <AlertTitle>Why isn&apos;t the information always accurate?</AlertTitle>
        <Typography variant="body1" component="p">
          The information comes from an Amazon.com API that we are lucky enough
          to have access to. The API is managed by Amazon and sellers have the
          option not to expose their prices via the API. If you are not seeing
          the same prices come back from the API, it is{' '}
          <strong>not our fault</strong>, the seller selling those products does
          not want to expose this information.
        </Typography>
        <Typography
          variant="body1"
          component="p"
          sx={{
            marginTop: 1
          }}
        >
          The API also does not expose information about coupons, Subscribe &
          Save or other discounts. The information you see around the site where
          products have discounts and promotions is{' '}
          <strong>manually maintained</strong> by our staff, there is no API.
        </Typography>
      </Alert>
    </Box>
  );
}
